import type { UtilizationThreshold } from './type';

/**
 * Derives the utilization color band from the numeric percentage value.
 * ≤80% = green, 81-90% = amber, >90% = red
 */
export function getUtilizationThreshold(value: number): UtilizationThreshold {
  if (value > 90) {
    return 'red';
  }

  if (value > 80) {
    return 'amber';
  }

  return 'green';
}

const TITLE_SECTION_CONSTANTS = {
  LICENSE_INTELLIGENCE: 'License Intelligence',
  LICENSE_SNAPSHOT: 'License Snapshot',
  LICENSE: 'License',
  ACTIVE: 'Active',
  TOTAL_LICENSE_SPEND: 'TOTAL LICENSE SPEND',
  LICENSE_UTILIZATION: 'LICENSE UTILIZATION',
  LICENSE_UTILIZATION_SUB: '3,847 / 4,200 FUE',
  COST_PER_IDENTITY: 'COST PER IDENTITY',
  COST_PER_USER_SUB: '21.5K Total Users',
  POTENTIAL_SAVINGS: 'POTENTIAL SAVINGS',
  POTENTIAL_SAVINGS_SUB: '612 FUE recoverable',
  YOY_LABEL: 'YoY',
  NULL_VALUE_TOOLTIP: 'No active accounts found for this vendor',
  NO_SIMULATION_SUBTITLE: '',
  DASH: '\u2014',
} as const;

export default TITLE_SECTION_CONSTANTS;
